export const T = {
  en_GB: {
    noValuesSelected: "No values selected",
    selected: (count: string) => `${count} selected`,
    isEmpty: "Is empty",
    isNotEmpty: "Is not empty",
    yes: "Yes",
    no: "No",
    today: "Today",
    thisWeek: "This week",
    thisMonth: "This month",
    thisQuarter: "This quarter",
    thisYear: "This year",
    olderThanMonth: "More than a month ago",
    olderThanQuarter: "More than a quarter ago",
    olderThanHalfYear: "More than 6 months ago",
    olderThanYear: "More than a year ago",
    favouriteHint: "Clients you have starred",
    selectTitle: (title: string) => `Select ${title}`,
    selectDescription: (count: string) =>
      `Choose one or more values for this filter. ${count} selected.`,
  },
  nb_NO: {
    noValuesSelected: "Ingen verdier valgt",
    selected: (count: string) => `${count} valgt`,
    isEmpty: "Er tom",
    isNotEmpty: "Er ikke tom",
    yes: "Ja",
    no: "Nei",
    today: "I dag",
    thisWeek: "Denne uken",
    thisMonth: "Denne måneden",
    thisQuarter: "Dette kvartalet",
    thisYear: "Dette året",
    olderThanMonth: "Mer enn en måned siden",
    olderThanQuarter: "Mer enn et kvartal siden",
    olderThanHalfYear: "Mer enn 6 måneder siden",
    olderThanYear: "Mer enn et år siden",
    favouriteHint: "Kunder du har favorittmerket",
    selectTitle: (title: string) => `Velg ${title}`,
    selectDescription: (count: string) =>
      `Velg én eller flere verdier for dette filteret. ${count} valgt.`,
  },
} as const;
